import type { ResponseMessage } from "@kiddocare-platform/portal-common/base";
import { BaseService } from "@kiddocare-platform/portal-common/base";
import type { System, SystemParameter, SystemValue } from "@kiddocare-platform/portal-common/platform";

export class PlatformIntegrationService extends BaseService {

  public async getSystems(): Promise<ResponseMessage<System[]>> {
    try {
      const response = await this.AxiosInstance.get(`/pediatrician/integration/getSystems`);
      return response.data;
    } catch (error: any) {
      this.log.error("getSystems", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async getParametersByIdSystem(idSystem: bigint): Promise<ResponseMessage<SystemParameter[]>> {
    try {
      const response = await this.AxiosInstance.get(`/pediatrician/integration/getParametersByIdSystem/${idSystem}`);
      return response.data;
    } catch (error: any) {
      this.log.error("getParametersByIdSystem", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async getValueAccountByIdSystem(idSystem: bigint): Promise<ResponseMessage<SystemValue[]>> {
    try {
      const response = await this.AxiosInstance.get(`/pediatrician/integration/getValueAccountByIdSystem/${idSystem}`);
      return response.data;
    } catch (error: any) {
      this.log.error("getValueAccountByIdSystem", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async addAccountValue(data: SystemValue[]): Promise<ResponseMessage<unknown>> {
    try {
      const response = await this.AxiosInstance.post(`/pediatrician/integration/addAccountValue`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("addAccountValue", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}